import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';

export default function AppDatagridTable({
  height = '80vh',
  tableData,
  rowHeight = 40,
  checkboxSelection = true,
}) {
  const dataRows = tableData?.rows?.map((r, i) => ({ ...r, id: r._id ?? i, slNo: i + 1 }));

  return (
    <Box sx={{ height: height, width: '100%' }}>
      <DataGrid
        rows={dataRows ?? []}
        columns={tableData?.columns ?? []}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 25,
            },
          },
        }}
        pageSizeOptions={[25]}
        rowHeight={rowHeight}
        checkboxSelection={checkboxSelection}
        disableRowSelectionOnClick={true}
        disableSelectionOnClick
      />
    </Box>
  );
}
